import { TweenLite, Power2 } from 'gsap';

export class RippleEffect {
    constructor(container) {
        this.doneCallback = () => null;
        this.animationDuration = 800;
        this.isComplete = false;
        this.halfAnimationSizePercentage = 0.75;
        this.container = container;

        this.ripple = document.createElement('span');

        this.ripple.style.position = 'absolute';
        this.ripple.style.pointerEvents = 'none';
        this.ripple.style.display = 'block';
        this.ripple.style.top = '50%';
        this.ripple.style.left = '50%';
        this.ripple.style.borderRadius = '50%';
        this.ripple.style.transform = 'translate(-50%, -50%)';
        this.ripple.style.backgroundColor = 'rgba(0, 0, 0, .1)';
        this.ripple.style.zIndex = '1';

        this.container.style.overflow = 'hidden';
        this.container.appendChild(this.ripple);
    }

    backgroundColor(color) {
        this.ripple.style.backgroundColor = `${color}`;
        return this;
    }

    position(x, y) {
        this.ripple.style.top = `${y}`;
        this.ripple.style.left = `${x}`;
        return this;
    }

    duration(milliseconds) {
        this.animationDuration = milliseconds;
        return this;
    }

    halfAnimationSize(percentage) {
        this.halfAnimationSizePercentage = percentage;
        return this;
    }

    done(callback = () => null) {
        this.doneCallback = callback;
        return this;
    }

    destroy() {
        if (this.container.contains(this.ripple)) {
            this.container.removeChild(this.ripple);
        }
        this.doneCallback();
    }

    halfAnimation() {
        const startSize = this.container.clientWidth * 0.1;
        const size = this.container.clientWidth * this.halfAnimationSizePercentage;

        TweenLite.set(this.ripple, {
            width: startSize,
            height: startSize
        });
        TweenLite.to(this.ripple, this.animationDuration / 1000, {
            width: size,
            height: size,
            ease: Power2.easeOut
        });
    }

    fullAnimation() {
        const size = this.container.clientWidth * 2;

        TweenLite.to(this.ripple, this.animationDuration / 1000, {
            width: size,
            height: size,
            opacity: 0,
            ease: Power2.easeOut,
            onComplete: () => {
                this.isComplete = true;
                this.destroy();
            }
        });
    }

    cancel() {
        TweenLite.to(this.ripple, 0.5, {
            opacity: 0,
            onComplete: () => {
                this.destroy();
            }
        });
    }
}
